<template>
  <div style="background: #f9f9f9; padding-bottom: 80px" class="adaptiveMobileNewClass">
    <div class="new_top_nap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/dynamicState' }">水泵协会</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">协会简报</el-breadcrumb-item>
        <el-breadcrumb-item v-if="titleName">{{ titleName }}</el-breadcrumb-item>
      </el-breadcrumb>
      <audio preload="auto" controls ref="audio" style="display: none">
        <source src="../../../assets/audio/turning.mp3" type="audio/mpeg" />
      </audio>
    </div>

    <div class="new_con" v-loading="loading">
      <h2>{{ metaTitle }}</h2>
      <div class="home">
        <div class="turnClass">
          <div id="flipbook" class="flipbookClass" ref="flipbookref">
            <div
              v-for="item in imageList"
              class="flipbook__item"
              :style="`
          background:url(${item.url}) no-repeat 100% 100%

          `"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { getBrief } from "../../../utils/associationApi";

import turn from "../../../utils/turn";

export default {
  //   新闻
  name: "briefInfo",
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.metaKeywords
        },
        {
          // set meta
          name: "description",
          content: this.metaDescription
        }
      ]
    };
  },
  components: {},
  data() {
    return {
      loading: false,
      config: {
        url: window.location.href,
        disabled: [
          "douban",
          "linkedin",
          "diandian",
          "qq",
          "qzone",
          "tencent",
          "google",
          "twitter",
          "tencent",
          "weibo"
        ]
      },
      uuid: "",
      briefDetail: "",
      imageList: [],
      fistList: [],
      titleName: "",
      metaTitle: "",
      metaKeywords: "",
      metaDescription: "",
      bookOptions: []
    };
  },
  created() {
    this.uuid = this.$route.params.uuid;
    this.titleName = "";
    this.getBrief();
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor"
    })
  },
  mounted() {
    // this.onTurn();
    let audio = this.$refs.audio;
    $("#flipbook").on("click", function(event) {
      // console.log(audio);
      audio
        .play()
        .then(() => {
          // console.log("音频播放成功:");
        })
        .catch(err => {
          console.error("尝试播放音频失败:");
        });
    });
  },
  destroyed() {},
  methods: {
    onTurn() {
      this.$nextTick(() => {
        $("#flipbook").turn({
          autoCenter: false,
          height: 800,
          width: 1200,
          display: "double", // 显示：single=单页，double=双页，默认双页
          page: 1, // 默认显示第几页
          pages: $("#flipbook").children().length,
          gradients: true, // 折叠处的光泽渐变，主要体现翻页的立体感、真实感
          turnCorners: "bl,br,tl,tr", //翻页动画开始的起始位置bl,br （左下，右下）tl,tr（左上，右上） or bl,tr（左下，右上）
          acceleration: true,
          when: {
            turned(event, page, view) {
            }
          }
        });
        // $("#flipbook").bind("first", function(event) { //卷叶
        //   console.log('当前页面是第一页');
        //   $("#flipbook").turn("peel","tr"); // 右上
        // });
        // $("#flipbook").bind("last",function(event){
        //   console.log('当前页面是最后一页');
        //   $("#flipbook").turn("peel","bl"); //左下
        // });
      });
    },

    getBrief() {
      getBrief(this.uuid)
        .then(res => {
          this.briefDetail = res;
          this.metaKeywords = res.name;
          this.metaDescription = res.name;
          this.metaTitle = res.name;
          this.titleName = res.name;
          // this.imageList = res.imageList;
          if (res.imageList.length > 0) {
            this.imageList = res.imageList;
            // console.log(res.imageList)
            // res.imageList.forEach((val,index ) =>{
            //   this.fistList.push(val.url)
            // })
            // this.imageList = this.fistList;
          }

          this.onTurn();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTurn(newPage) {
      console.log("当前页:", newPage);
    },
    handleFlipStart() {
      console.log("开始翻页");
    },
    handleFlipEnd() {
      console.log("翻页结束");
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/dist/css/share.min.css";

.blue {
  color: #009999;
}

.red {
  color: #d60000;
}

.new_top_nap {
  font-size: 14px;
  color: #808080;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;

  span {
    color: #808080;
  }
}
.new_con {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 10px;
  background: #fff;

  h2 {
    color: #082a48;
    //border-bottom: 1px solid #efefef;
    text-align: center;
    font-size: 26px;
    padding: 15px 0;
  }
}

* {
  touch-action: pan-y; // 启用单指垂直平移手势
}

.home {
  position: relative;
  height: 800px;
  width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0; //固定元素,不被挤压
  .turnClass {
    display: flex;
    flex-direction: column;
    align-items: center;
    .flipbookClass {
      position: relative;
      box-shadow: 5px 0px 5px 2px rgba(0, 0, 0, 0.16); // 阴
      .flipbook__item {
        background-repeat: no-repeat; // 不重复
        background-size: cover; // 铺满
        background-position: center center; //中心
        transform-origin: 50% 50%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/association/components/briefInfo.vue